import axios from 'axios'

window.axios = axios



// WEBPACK FOOTER //
// ./resources/js/plugins/axios.js